import _extends from '../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default, { useState, useRef, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import ArrowBackIcon from '../../widgets/streamline-icon/ArrowBackIcon.js';
import ArrowForwardIcon from '../../widgets/streamline-icon/ArrowForwardIcon.js';
import CustomIconButton from '../../widgets/button/custom-icon-button/CustomIconButton.js';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    pictureText: {
      maxWidth: theme.spacing(62.5)
    },
    pictureTextSkele: {
      marginTop: theme.spacing(0.8)
    },
    galleryBox: _defineProperty({
      maxWidth: theme.spacing(96.25)
    }, theme.breakpoints.down("sm"), {
      maxWidth: "100%"
    }),
    slideCount: _defineProperty({
      marginRight: theme.spacing(3)
    }, theme.breakpoints.down("xs"), {
      margin: theme.spacing(2, 0, 1, 0)
    }),
    btn: {
      color: theme.palette.text.black,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      "& i": {
        padding: 0,
        fontSize: theme.spacing(2.5)
      },
      "&:first-of-type": {
        marginRight: theme.spacing(2)
      }
    },
    btnSize: {
      width: theme.spacing(6),
      height: theme.spacing(6)
    },
    inlineBlock: {
      display: "inline-block"
    },
    mxAuto: {
      margin: theme.spacing(0, "auto", 0, "auto")
    },
    mr2: {
      marginRight: theme.spacing(2)
    },
    arrow: {
      color: theme.palette.text.black
    }
  };
});
var PictureGallery = function PictureGallery(_ref) {
  var _items$activeItemInde;
  var images = _ref.images,
    blogStyle = _ref.blogStyle;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var _window = window,
    width = _window.innerWidth;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeItemIndex = _useState4[0],
    setActiveItemIndex = _useState4[1];
  var sliderRef = useRef();
  useEffect(function () {
    if (images) {
      setItems(images);
    }
  }, [images]);
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: function afterChange(current) {
      setActiveItemIndex(current);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.galleryBox,
    mx: "auto",
    mb: blogStyle ? 4 : isExtraSmallScreen() ? 4 : 8
  }, items ? /*#__PURE__*/React__default.createElement(Slider, _extends({}, settings, {
    ref: sliderRef
  }), items.map(function (i) {
    var _i$file;
    return /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      key: i === null || i === void 0 ? void 0 : i.title,
      src: retrieveContentfulImage(i === null || i === void 0 || (_i$file = i.file) === null || _i$file === void 0 ? void 0 : _i$file.url, {
        width: width > 770 ? 770 : width - 32
      }),
      alt: (i === null || i === void 0 ? void 0 : i.title) || ""
    });
  })) : /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "rect",
    height: isExtraSmallScreen() ? 300 : 400
  }), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    flexDirection: isExtraSmallScreen() ? "column" : "",
    mt: isExtraSmallScreen() ? 0.25 : 2.25
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: clsx(classes.pictureText, classes.mxAuto),
    variant: "body1"
  }, items ? (_items$activeItemInde = items[activeItemIndex]) === null || _items$activeItemInde === void 0 ? void 0 : _items$activeItemInde.description : /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "rect",
    width: 300,
    className: isExtraSmallScreen() ? classes.pictureTextSkele : ""
  })), /*#__PURE__*/React__default.createElement(Box, {
    display: !isExtraSmallScreen() ? "flex" : "",
    alignItems: !isExtraSmallScreen() ? "center" : ""
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.slideCount
  }, items ? "".concat(activeItemIndex + 1, "/").concat(items === null || items === void 0 ? void 0 : items.length) : /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "rect",
    width: 40,
    className: isExtraSmallScreen() ? classes.mxAuto : ""
  })), items ? /*#__PURE__*/React__default.createElement(CustomIconButton, {
    className: clsx(classes.btn, classes.mr2, classes.btnSize),
    disableRipple: true,
    onClick: function onClick() {
      return sliderRef.current.slickPrev();
    }
  }, /*#__PURE__*/React__default.createElement(ArrowBackIcon, {
    className: classes.arrow
  })) : /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "circle",
    className: clsx(classes.mr2, classes.btnSize, _defineProperty({}, classes.inlineBlock, isExtraSmallScreen()))
  }), items ? /*#__PURE__*/React__default.createElement(CustomIconButton, {
    className: clsx(classes.btn, classes.btnSize),
    disableRipple: true,
    onClick: function onClick() {
      return sliderRef.current.slickNext();
    }
  }, /*#__PURE__*/React__default.createElement(ArrowForwardIcon, {
    className: classes.arrow
  })) : /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "circle",
    className: clsx(classes.btnSize, _defineProperty({}, classes.inlineBlock, isExtraSmallScreen()))
  }))));
};
PictureGallery.propTypes = {
  images: PropTypes__default.arrayOf(PropTypes__default.shape({
    file: PropTypes__default.shape({
      url: PropTypes__default.string
    }),
    title: PropTypes__default.string
  })),
  blogStyle: PropTypes__default.bool
};

export { PictureGallery as default };
//# sourceMappingURL=PictureGallery.js.map
